import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { NgxFloatUiDirective } from 'ngx-float-ui';
import { RouterLink } from '@angular/router';
import { ChainSettingsState, SettingsRepository } from '../../../repository';
import { NgIcon } from '@ng-icons/core';

@Component({
  selector: 'common-rebalancing-settings-info',
  standalone: true,
  imports: [
    CommonModule,
    TranslateModule,
    NgxFloatUiDirective,
    RouterLink,
    NgIcon,
  ],
  templateUrl: './settings-info.component.html',
  styleUrls: ['./settings-info.component.scss'],
})
export class SettingsInfoComponent implements OnInit {
  @Input()
  public editable = true;

  @Output()
  public openSettingsModal: EventEmitter<void> = new EventEmitter<void>();

  public isAnyInfoShown = false;

  public enabledLiquiditySourcesCount: number;
  public totalLiquiditySourcesCount: number;
  public liquiditySourcesTooltip: string;

  constructor(private readonly settingsRepository: SettingsRepository) {}

  public get activeChainSettingsState(): ChainSettingsState | undefined {
    return this.settingsRepository.getActiveChainSetting();
  }

  public get maxSlippageString(): string {
    if (!this.activeChainSettingsState?.maxSlippage) {
      return 'Click to set.';
    }
    let msg = `Max slippage: ${this.activeChainSettingsState.maxSlippage * 100}%.`;
    if (this.editable) {
      msg += ' Click to edit.';
    }
    return msg;
  }

  public get maxPriceImpactString(): string {
    if (!this.activeChainSettingsState?.maxPriceImpact) {
      return 'Click to set.';
    }
    let msg = `Max price impact: ${this.activeChainSettingsState.maxPriceImpact * 100}%.`;
    if (this.editable) {
      msg += ' Click to edit.';
    }
    return msg;
  }

  public get minExpirySecString(): string {
    if (!this.activeChainSettingsState?.minExpirySec) {
      return 'Click to set.';
    }
    let msg = `Min quote expiry: ${this.activeChainSettingsState.minExpirySec} sec.`;
    if (this.editable) {
      msg += ' Click to edit.';
    }
    return msg;
  }

  public ngOnInit(): void {
    this.loadLiquiditySourcesCounts();

    if (!this.isAnyInfoShown) {
      this.isAnyInfoShown = !!this.activeChainSettingsState;
    }
  }

  private loadLiquiditySourcesCounts(): void {
    const config = this.activeChainSettingsState?.liquiditySourceConfig;
    if (config) {
      this.enabledLiquiditySourcesCount = config.getEnabledCount();
      this.totalLiquiditySourcesCount = config.getTotalCount();
      this.liquiditySourcesTooltip = `${this.enabledLiquiditySourcesCount} of ${this.totalLiquiditySourcesCount} liquidity sources are enabled. Click to edit.`;
      this.isAnyInfoShown =
        this.enabledLiquiditySourcesCount !== this.totalLiquiditySourcesCount;
    }
  }

  public onOpenSettingsModalClick(): void {
    if (this.editable) {
      this.openSettingsModal.emit();
    }
  }
}
